import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

const STARTER_PRICE_ID = process.env.REACT_APP_STARTER_PRICE;
const PRO_PRICE_ID = process.env.REACT_APP_PRO_PRICE;

export default function Checkout() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [paddleReady, setPaddleReady] = useState(false);

  const plan = searchParams.get("plan"); // starter | pro
  const token = searchParams.get("token");

  // 1️⃣ Initial setup
  useEffect(() => {
    if (!plan || !token) {
      navigate("/gauth", { replace: true });
      return;
    }

    // Store JWT
    localStorage.setItem("token", token);

    // Clean URL
    window.history.replaceState({}, document.title, `/checkout?plan=${plan}`);

    loadPaddle();
  }, []);

  // 2️⃣ Trigger checkout ONLY when Paddle is ready
  useEffect(() => {
    if (paddleReady) {
      handleCheckout();
    }
  }, [paddleReady]);

  // 3️⃣ Load Paddle script safely
  const loadPaddle = () => {
    if (window.Paddle) {
      initPaddle();
      return;
    }

    const script = document.createElement("script");
    script.src = "https://cdn.paddle.com/paddle/v2/paddle.js";
    script.async = true;

    script.onload = initPaddle;
    document.body.appendChild(script);
  };

  // 4️⃣ Initialize Paddle (v2 correct way)
  const initPaddle = () => {
    window.Paddle.Environment.set("sandbox"); // change to production later

    window.Paddle.Initialize({
      token: process.env.REACT_APP_PADDLE_CLIENT_TOKEN,
      eventCallback: (data) => {
        console.log("Paddle event:", data);

        if (data.name === "checkout.completed") {
          navigate("/createtweet", {
            replace: true,
            state: { loginSuccess: true },
          });
        }
      },
    });

    setPaddleReady(true);
  };

  // 5️⃣ Open checkout
  const handleCheckout = () => {
    const priceId = plan === "starter" ? STARTER_PRICE_ID : PRO_PRICE_ID;

    if (!priceId) {
      console.error("Missing price ID for plan:", plan);
      return;
    }

    window.Paddle.Checkout.open({
      items: [{ priceId, quantity: 1 }],
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="bg-white rounded-xl shadow-md p-8 max-w-md text-center">
        <h1 className="text-2xl font-bold mb-4">
          Completing your subscription
        </h1>

        <p className="text-gray-600 mb-6">
          You selected the{" "}
          <span className="font-semibold capitalize">{plan}</span> plan. Please
          complete the payment to continue.
        </p>

        <p className="text-sm text-gray-500">Opening secure payment…</p>
      </div>
    </div>
  );
}
